export default {
  title: 'Benvenuto',
  subtitle: 'Accedi per gestire il tuo account e gli ordini',
  benefits: {
    earn_points: {
      title: 'Guadagna punti ad ogni ordine',
      description: 'Accumula punti e sblocca premi esclusivi',
    },
    get_deals: {
      title: 'Ricevi sconti esclusivi',
      description: 'Usa i tuoi punti per ottenere articoli gratuiti',
    },
    redeem_points: {
      title: 'Riscatta punti per cibo gratuito',
      description: 'Accedi alle promozioni riservate ai membri',
    },
  },
};
